var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "add-label-dialog",
          staticStyle: { "margin-top": "4vh" },
          attrs: {
            title: _vm.titleName,
            visible: _vm.dialogVisable,
            "modal-append-to-body": false,
            width: "850px",
            height: "504px",
            "close-on-click-modal": false
          },
          on: {
            close: _vm.closeDialog,
            "update:visible": function($event) {
              _vm.dialogVisable = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
              _c("span", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.myType == 5 ? "消息名称" : "SOP名称"))
              ]),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.myType == 5
                        ? _vm.detaildata.msgName
                        : _vm.detaildata.sopName
                    ) +
                    " "
                )
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
              _c("span", { staticClass: "label" }, [_vm._v("选择员工")]),
              _c("div", [
                _vm._v(
                  " 已选择 " +
                    _vm._s(
                      _vm.myType == 5
                        ? _vm.detaildata.userVoList
                          ? _vm.detaildata.userVoList.length
                          : ""
                        : _vm.detaildata.userListSize
                    ) +
                    " 位 "
                )
              ])
            ]),
            _vm.myType != 5 &&
            _vm.detaildata.userList &&
            _vm.detaildata.userList.length != 0
              ? _c(
                  "div",
                  { staticClass: "select-wrap" },
                  _vm._l(_vm.detaildata.userList, function(item, index) {
                    return _c(
                      "el-tag",
                      { key: index, attrs: { size: "small" } },
                      [_vm._v(" " + _vm._s(item.userName) + " ")]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm.myType == 5 &&
            _vm.detaildata.userVoList &&
            _vm.detaildata.userVoList.length != 0
              ? _c(
                  "div",
                  { staticClass: "select-wrap" },
                  _vm._l(_vm.detaildata.userVoList, function(item, index) {
                    return _c(
                      "el-tag",
                      { key: index, attrs: { size: "small" } },
                      [_vm._v(" " + _vm._s(item.userName) + " ")]
                    )
                  }),
                  1
                )
              : _vm._e(),
            _vm.myType == 5 &&
            _vm.detaildata.cusTotal &&
            _vm.detaildata.cusTotal != null
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "span",
                    {
                      staticClass: "required",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("*")]
                  ),
                  _c("span", { staticClass: "label" }, [_vm._v("服务客户")]),
                  _c("div", [
                    _c("div", { staticClass: "after-select" }, [
                      _c("div", [
                        _vm._v(
                          "预计触达" +
                            _vm._s(_vm.detaildata.cusTotal) +
                            "位客户"
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
              _c("span", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.myType == 5 ? "发送内容" : "任务详情"))
              ])
            ]),
            _c(
              "div",
              { staticClass: "task-detail" },
              [
                _vm._t("taskDetail", function() {
                  return [
                    _vm.myType == 1
                      ? [
                          _c(
                            "div",
                            { staticClass: "detial-item" },
                            [
                              _vm._v(" 通过好友 "),
                              _c("el-input", {
                                staticClass: "number-input",
                                staticStyle: { width: "80px" },
                                attrs: {
                                  type: "number",
                                  size: "small",
                                  readonly: "",
                                  min: 0,
                                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                                },
                                model: {
                                  value: _vm.hours,
                                  callback: function($$v) {
                                    _vm.hours = $$v
                                  },
                                  expression: "hours"
                                }
                              }),
                              _vm._v(" 小时 "),
                              _c("el-input", {
                                staticClass: "number-input",
                                staticStyle: { width: "80px" },
                                attrs: {
                                  type: "number",
                                  size: "small",
                                  readonly: "",
                                  min: 0,
                                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                                },
                                model: {
                                  value: _vm.minute,
                                  callback: function($$v) {
                                    _vm.minute = $$v
                                  },
                                  expression: "minute"
                                }
                              }),
                              _vm._v(" 分钟 后发送 ")
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm.myType == 2
                      ? [
                          _c(
                            "div",
                            { staticClass: "detial-item" },
                            [
                              _c(
                                "span",
                                [
                                  _vm._v(" 发送时间：客户生日前 "),
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "60px",
                                      margin: "0 5px"
                                    },
                                    attrs: { size: "small", readonly: "" },
                                    model: {
                                      value: _vm.daysAgo,
                                      callback: function($$v) {
                                        _vm.daysAgo = $$v
                                      },
                                      expression: "daysAgo"
                                    }
                                  }),
                                  _vm._v("天")
                                ],
                                1
                              ),
                              _c("el-time-picker", {
                                staticStyle: {
                                  width: "100px",
                                  margin: "0 12px"
                                },
                                attrs: {
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  readonly: "",
                                  size: "small",
                                  clearable: false,
                                  placeholder: "任意时间点"
                                },
                                model: {
                                  value: _vm.value1,
                                  callback: function($$v) {
                                    _vm.value1 = $$v
                                  },
                                  expression: "value1"
                                }
                              }),
                              _vm._v(" 发送 "),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "将于客户公历生日当天发送祝福",
                                    placement: "top-start"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-question icon-style"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm.myType == 3
                      ? [
                          _c("div", { staticClass: "detial-item" }, [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("起止时间")
                            ]),
                            _c(
                              "div",
                              [
                                _c("el-date-picker", {
                                  staticStyle: {
                                    width: "240px",
                                    "margin-right": "10px"
                                  },
                                  attrs: {
                                    size: "mini",
                                    readonly: "",
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd",
                                    format: "yyyy-MM-dd",
                                    "range-separator": "~",
                                    clearable: false
                                  },
                                  model: {
                                    value: _vm.searchSelectTime,
                                    callback: function($$v) {
                                      _vm.searchSelectTime = $$v
                                    },
                                    expression: "searchSelectTime"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      : _vm._e()
                  ]
                }),
                _c("MyUploadDetail", {
                  attrs: { myType: _vm.myType, upLoadData: _vm.upLoadData }
                })
              ],
              2
            )
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.confirmWeicome()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }